"use client";

export default function GlobalError({ error, reset }: { error: Error & { digest?: string }; reset: () => void }) {
  return (
    <html lang="en" className="dark">
      <body style={{ background: "#0a0a0a", color: "#fff", fontFamily: "system-ui, sans-serif", display: "grid", placeItems: "center", minHeight: "100vh", margin: 0 }}>
        <div style={{ textAlign: "center", padding: 32 }}>
          <h1 style={{ fontSize: 28, fontWeight: 700 }}>Something went wrong</h1>
          <p style={{ color: "#a1a1aa", marginTop: 12 }}>Please try again later.</p>
          {error.digest && <p style={{ color: "#71717a", fontSize: 12, marginTop: 8 }}>Reference: {error.digest}</p>}
          <button onClick={reset} style={{ marginTop: 24, padding: "10px 20px", borderRadius: 12, background: "#5e99ff", color: "#fff", border: 0, cursor: "pointer" }}>
            Try again
          </button>
        </div>
      </body>
    </html>
  );
}
